"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import Toast from "vwa/components/Toast";

import eventDescriptorStore from "./../store/eventDescriptors";
import sessionStore from "./../store/session";  

import getModificationsByRef from "vfu/getModificationsByRef";

import {getUserId} from "./../utils/user";

async function updateEventDescriptor(eventDescriptor){
	try {
		const oldEventDescriptor = eventDescriptorStore.get(eventDescriptor._id);
		const modifications = getModificationsByRef(oldEventDescriptor, eventDescriptor);
		
		if(!modifications){
			return;
		}
		
		if(modifications.carriers){
			modifications.carriers = eventDescriptor.carriers;
		}
		
		if(modifications.pois){
			modifications.pois = eventDescriptor.pois;
		}
		
		const response = await api.put("eventDescriptors", {
			eventDescriptors: [eventDescriptor._id],
			modifications
		});
		dispatcher.dispatch("updateEventDescriptor", response.eventDescriptors[0]);
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}

export default async function updateNotificationConfig(eventDescriptor, notificationConfig) {
	await updateEventDescriptor(eventDescriptor);
	try {
		const userId = getUserId();
		if(!userId){
			return;
		}
		
		//utilsba ki?
		const oldNotificationConfig = sessionStore.get().user.services.find(e => e.type == "NotificationSet" && e.value.descriptor == eventDescriptor._id).value;
		const modifications = getModificationsByRef(oldNotificationConfig, notificationConfig);
		
		if(!modifications){
			return;
		}
		
		const response = await api.put("users/notifications", {
			_id: getUserId(),
			descriptors: [eventDescriptor._id],
			modifications
		});
		dispatcher.dispatch("updateNotificationConfig", response.notifications[0]);
		return true;	
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/api/updateNotificationConfig.js